import { FormStore } from '@estee/elc-form';
import { RampFormValidator } from '../../controllers/common/RampFormValidator';
import { IMobileValidation } from './Config';
import { StringSchema, string as yupString } from 'yup';

export type IUserFormValues = Record<string, string | undefined>;

interface MobileValidatorParams {
    formStore: IUserFormValues;
    patterns: IMobileValidation;
    errorMessage: string;
}

type MobileValidator = (configs: MobileValidatorParams) => StringSchema;

export class UserFormStore extends FormStore<IUserFormValues> {
    constructor(initialValues: IUserFormValues = {}) {
        super({
            initialValues: initialValues,
            formValidator: new RampFormValidator()
        });
        (this.formValidator as RampFormValidator).registerValidation('mobile', this.validateMobile);
    }

    // HACK: A registered FormValidator method accepts up to 2 parameters by design (msg and params, see @estee/elc-form FormValidator), we utilize the 'msg' positional parameter to pass in our custom configs.
    public validateMobile: MobileValidator = ({
        patterns = {} as IMobileValidation,
        errorMessage = ''
    }) => {
        const code = this.values.areaCode as string;
        if (patterns[code] || patterns.default) {
            const regExp = new RegExp(patterns[code] || patterns.default);

            return yupString().matches(regExp, errorMessage);
        } else {
            return yupString();
        }
    };
}
